var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BBPCheckbox',{attrs:{"title":_vm.input.title,"defaultValue":_vm.checked,"disable":_vm.input.disabled},on:{"change":_vm.changeValue}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bf0ac0b6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main/BBPForm/BBPCheckboxForm/BBPCheckboxForm.vue
// module id = null
// module chunks = 